import React from "react";
import { FWSection } from "../../../../design-system/fw";

/** הערות — טקסט פשוט */
export default function CancellationCard() {
  return (
    <FWSection title="הערות">
      <p className="fw-ui-results-hint hr-order-notes__text" style={{ margin: 0, lineHeight: 1.55 }}>
        פירוט מדויק של מדיניות הביטול והחיובים יוצג בעמוד התשלום ובאישור הספק, בהתאם לסוג הכרטיס שנבחר.
      </p>
    </FWSection>
  );
}
